type ScrollIntoViewOptions = {
  behavior?: 'auto' | 'smooth'
  offset?: number
}

export const documentScrollTo = (query: string, options?: ScrollIntoViewOptions) => {
  const element = document.querySelector(query)
  if (element) {
    const { behavior = 'smooth', offset = 0 } = options || {}
    const rect = element.getBoundingClientRect()
    const scrollTop = window.scrollY || document.documentElement.scrollTop

    window.scrollTo({
      top: rect.top + scrollTop + offset,
      behavior,
    })
  }
}
